import * as Actions from './actions';
import { ICrmDomain, initialState } from './model';

export const crmReducer = (
  state: ICrmDomain = initialState,
  action: Actions.CrmAction
): ICrmDomain => {
  switch (action.type) {
    case Actions.SET_TYPE_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          typeCodes: action.value,
        },
      };
    case Actions.SET_COUNTRY_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          countryCodes: action.value,
        },
      };
    case Actions.SET_STAGE_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          leadStageCode: action.value,
        },
      };
    case Actions.SET_SCORE_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          leadScoreGte: action.value,
        },
      };
    case Actions.SET_MANAGER_TEXT_FILTER:
      return {
        ...state,
        data: {
          ...state.data,
          managerText: action.value,
        },
      };
    case Actions.SET_MANAGER_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          managerId: action.value,
        },
      };
    case Actions.SET_TERM_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          term: action.value,
        },
      };
    case Actions.SET_BOOKING_ACTIVITY_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          bookingActivityStatus: action.value,
        },
      };
    case Actions.RESET_WHOLE_FILTER:
      return {
        ...state,
        data: {
          ...initialState.data,
        },
        filters: {
          ...initialState.filters,
        },
        confirmedFilters: {
          ...initialState.confirmedFilters,
        },
      };
    case Actions.IS_DIRTY_EDIT_COMPANY_PROFILE:
      return {
        ...state,
        data: {
          ...initialState.data,
          isDirtyEditCompanyProfile: action.value,
        },
      };
    case Actions.IS_DIRTY_EDIT_CONTACT_PROFILE:
      return {
        ...state,
        data: {
          ...initialState.data,
          isDirtyEditContactProfile: action.value,
        },
      };
    case Actions.OPEN_SUBSCRIBE_TO_ALL_NOTIFICATIONS_MODAL:
      return {
        ...state,
        subscription: {
          ...state.subscription,
          subscribeModalOpen: true,
        },
      };
    case Actions.CLOSE_SUBSCRIBE_TO_ALL_NOTIFICATIONS_MODAL:
      return {
        ...state,
        subscription: {
          ...state.subscription,
          subscribeModalOpen: false,
        },
      };
    case Actions.OPEN_UNSUBSCRIBE_FROM_ALL_NOTIFICATIONS_MODAL:
      return {
        ...state,
        subscription: {
          ...state.subscription,
          unsubscribeModalOpen: true,
        },
      };
    case Actions.CLOSE_UNSUBSCRIBE_FROM_ALL_NOTIFICATIONS_MODAL:
      return {
        ...state,
        subscription: {
          ...state.subscription,
          unsubscribeModalOpen: false,
        },
      };
    case Actions.SET_NOTIFICATIONS_SUBSCRIPTION_PENDING:
      return {
        ...state,
        subscription: {
          ...state.subscription,
          isPending: action.value,
        },
      };
    case Actions.SET_CONFIRMED_FILTERS:
      return {
        ...state,
        confirmedFilters: {
          ...state.filters,
        },
      };
    default:
      return state;
  }
};
